import "./footer.css"

import React from "react";

import logo from "../../../../assets/images/logo.png";

import {useTranslate} from "../../../../hooks";

const Footer = () => {
    const date = new Date();
    const year = date.getFullYear();
    const footerText = useTranslate('FOOTER_TEXT')
    return (
        <footer className="app-footer">
            <div className="app-footer-logo">
                <a target="_blank" rel="noreferrer" href="//umbrellait.com">
                    <img src={logo} alt="logo.png"/>
                </a>
            </div>
            <div className="app-footer-text">
                © 2009-{year}. {footerText}
            </div>
        </footer>
    )
}

export default Footer